
<template>
    <div>
        <h3>Files</h3>
        <p>Upload files for the building/website e.g. quality photographs, tenant logos, floor plans, site handbook, S/C budget, S/C reconciliation pack</p>
        <p class="margin_bottom">You can select multiple files at once, either drag and drop or click for an open file dialog</p>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100 md-size-50">
                <div class="md-layout md-gutter fileupload-wrap">
                    <div class="md-layout-item md-size-25 md-form-label">
                        <md-icon>attach_file</md-icon>
                    </div>
                    <div class="md-layout-item">
                        <file-pond name="files"
                                   ref="pond"
                                   label-idle="Drop files / click here..."
                                   v-bind:allow-multiple="true"
                                   accepted-file-types="image/jpeg, image/png, image/bmp, image/gif, image/svg+xml, image/tiff, image/webp,
                                   application/pdf,
                                   application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                   application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                   application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                   text/csv,
                                   text/plain, application/rtf,
                                   video/mp4, video/mpeg, video/webm, video/ogg, video/x-msvideo" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import vueFilePond, { setOptions } from 'vue-filepond';
    import getCurrentConfig from "@/ts/customConfig";
    var currentConfig = getCurrentConfig();

    import FileHelp from "@/ts/fileHelp";

    setOptions({
        server: {
            url: `${currentConfig.apiBaseUrl}/files`, 
            process: '/process',
            restore: '/restore?id=',
            revert: '/revert',
        }
    });

    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);



    export default {
        name: 'FilePondUpload',
        components: {
            FilePond
        },
        methods: {
            validateFilePondStatus() {
                var respVal = {
                    valid: true,
                    errors: []
                };
                var status = this.$refs.pond._pond.status;
                if (FileHelp.statusBusy(status)) {
                    respVal.valid = false;
                    respVal.errors.push(["Please wait for all files to upload"]);
                }
                return respVal;
            },
            getFiles() {
                var x = this.$refs.pond.getFiles();
                var fileServerIds = x.map(FileHelp.toFileId);
                return fileServerIds;
            }
        }
    }
</script>

<style lang="scss">

    .fileupload-wrap {
        margin-bottom: 3rem;
    }

    .filepond--wrapper {

    }

</style>


<!--cref server="/api" https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types -->